export const INPUT_FIELDS_COUNT = 6;

export const pins = Array(INPUT_FIELDS_COUNT).fill('');
